import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, DependencyDto, IValueViewModel, SeriesDefinition, TagDateValue } from '../../models';
import { ChartConfigurationOption } from '../../wtFramework';
import { IidentifierAnalysisService } from './identifierAnalysis.service';
import { ReadResult } from './ReadResult';


class IdentifierAnalysisController implements angular.IComponentController, angular.IOnChanges {
    isLoading: boolean;
    loadingMessage: string;
    options: ChartConfigurationOption;
    dependencyDto: DependencyDto[];
    readData: ReadResult;
    data: TagDateValue[];
    series: SeriesDefinition<any>[];
    viewModels: { [guid: string]: IValueViewModel };
    insideDate: Date;
    outsideDate: Date;

    static $inject = [
        '$scope',
        'identifierAnalysisService'
    ];
    constructor(private _$scope: angular.IScope,
        private _identifierAnalysisService: IidentifierAnalysisService) {
    }

    $onInit() {
        const options = new ChartConfigurationOption();
        options.isTitleVisible = false;
        options.isLegendVisible = false;
        options.hasAbsolutePanesHeight = true;
        options.panes = this.options?.panes || [];
        this.options = options;
        this.data = this.data || [];
        this.series = this.series || [];
        this._$scope.$watch(() => this.options.crosshairDate, () => {
            this.insideDate = this.options.crosshairDate;
        });
    }

    $onChanges(onChangesObj: angular.IOnChangesObject): void {
        if ((onChangesObj['readData'] || onChangesObj['dependencyDto'])
            && this.readData && this.dependencyDto && this.options) {
            this.remap();
        }
        if (onChangesObj['outsideDate'] && this.options) {
            if (this.outsideDate !== this.options.crosshairDate) {
                this.options.crosshairDate = this.outsideDate;
            }
        }
    }

    private remap() {
        const data = this.readData;
        const ret = this._identifierAnalysisService.mapSeries(this.dependencyDto, this.viewModels);
        const panes: any[] = ret.panes;
        this.dependencyDto.forEach((d, i) => {
            try {
                const currentErrors = data.errors[d.guid];
                panes[i].areas = currentErrors;
            } catch (e) {
                console.error(e);
            }
        });
        this.series = ret.series;
        const display = (Object as any).assign({}, this.options.display, { xMin: data.xMin, xMax: data.xMax });
        this.options = (Object as any).assign({}, this.options, { display, panes });
        this.data = data.data;
    }
}

export const wtIdentifierAnalysis: ComponentDefinition = {
    componentId: 'wtIdentifierAnalysis',
    controller: IdentifierAnalysisController,
    template: require('./identifierAnalysis.component.html'),
    controllerAs: 'vm',
    bindings: {
        dependencyDto: '<',
        readData: '<',
        isLoading: '<?',
        loadingMessage: '<?',
        componentId: '<',
        viewModels: '<',
        insideDate: '=?',
        outsideDate: '<'
    }
};